import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { getDueDiligenceForm } from 'services/apiKYP'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { cloneDeep } from 'lodash'
import { getDataField } from 'utils/constants/dataFields'
import { DisplayAnswers } from 'components/DueDiligence/Questions'
import { formatToCPF } from 'brazilian-values'
import { formInfoinitialValues } from 'utils/constants/componentInitialValues'
import styles from './styles'

import { form } from './mockData'


function FormInfo(props) {
  const { id, showPersonInfo = true } = props
  const token = useSelector((state) => state.auth.access_token)
  const classes = styles()

  const [loading, setLoading] = useState(false)
  const [formResponses, setFormResponses] = useState(formInfoinitialValues)
  const [userData, setUserData] = useState({})

  const loadData = async () => {
    if (id) {
      setLoading(true)
      return getDueDiligenceForm(token, id)
        .then((response) => {
          return response.data
        })
        .catch(() => {
          toast.error('Houve um Erro ao carregar os dados do formulário')
          return form
        })
        .finally(() => {
          setLoading(false)
        })
    }
    return null
  }

  const initilizeStates = async () => {
    const responseData = await loadData()
    if (responseData?.owner) {
      setUserData(responseData.owner)
    }
    if (responseData?.answers?.length > 0) {
      const processedResponses = responseData.answers.map(
        (answer) => answer.answer_object,
      )

      const updatedValues = cloneDeep(formInfoinitialValues)

      processedResponses.forEach((answer) => {
        updatedValues[answer.question_name].has_answer = true
        updatedValues[answer.question_name][
          getDataField(answer.question_name)
        ] = answer[getDataField(answer.question_name)]
      })
      setFormResponses(updatedValues)
    }
  }

  useEffect(() => {
    initilizeStates()
  }, [])

  return (
    <div className={classes.root}>
      {loading ? (
        <h3>Carregando</h3>
      ) : (
        <div className={classes.container}>
          {showPersonInfo ? (
            <div className={classes.prospectData}>
              <h3 className={classes.title}>Dados do candidato</h3>
              <div>
                <p>
                  <span>CPF: </span>
                  {userData?.prospect?.person?.cpf && formatToCPF(userData?.prospect?.person?.cpf)}
                </p>
                <p className={classes.textCapitalize}>
                  <span>Nome: </span>
                  {userData?.prospect?.person?.name?.toLowerCase()}
                </p>
                <p>
                  <span>Email: </span>
                  {userData?.email}
                </p>
              </div>
            </div>
          ) : null}
          <div className={classes.wrapper}>
            <DisplayAnswers formResponses={formResponses} condensed={true} />
          </div>
        </div>
      )}
    </div>
  )
}

FormInfo.propTypes = {
  id: PropTypes.string,
}

FormInfo.defaultProps = {
  id: undefined,
}

export default FormInfo
